import "../App.css"

const GDesign = (props) => {
    const { url, name, description, } = props;
    return (
        <center>
        <article className='book text-center'>
            <img id="imgbd" height="200" width="300" src={url} alt='' />
            <h3>{name}</h3>
            <h2>{description}</h2>
        </article>
        </center>
    );
}
export default GDesign;